// extracted by mini-css-extract-plugin
export default {"required_asterisk":"RequiredAsterisk_required_asterisk__n64x-"};